<template>
  <div class="container">
    <iain-gap height="10" bg-color="#EEEEEE" />

    <div class="mini">
      <div class="cell">
        <div class="prepend">
          <div class="prepend-icon">
            <iain-image-domain w="28" h="28" src="static/img/icon3.png" />
          </div>
          <span class="prepend-label">报名截止时间:</span>
          <span>{{ detail.abortDate }}</span>
        </div>
      </div>

      <div class="cell">
        <div class="prepend">
          <div class="prepend-icon">
            <iain-image-domain w="28" h="28" src="static/img/icon4.png" />
          </div>
          <span class="prepend-label">活动管理员:</span>
          <iain-image-domain w="40" h="40" r="6" :src="initiator.initiatorAvatar" />
          <span class="prepend-admin">{{ initiator.initiatorName }}</span>
        </div>

        <div class="append">
          <van-button size="mini" type="FF5500">打赏</van-button>
          <van-button size="mini" type="FF5500">排行榜</van-button>
        </div>
      </div>
    </div>

    <iain-gap height="10" bg-color="#EEEEEE" />

    <div class="cell has-border">
      <div class="prepend">
        <div class="prepend-icon">
          <iain-image-domain w="28" h="32" src="static/img/icon5.png" />
        </div>
        <span class="prepend-label">活动时间:</span>
        <span>{{ detail.startDate }}</span>
      </div>
    </div>

    <div class="cell has-border">
      <div class="prepend">
        <div class="prepend-icon">
          <iain-image-domain w="28" h="32" src="static/img/icon6.png" />
        </div>
        <span class="prepend-label">举办地点:</span>
        <div class="prepend-location">{{ detail.address }}</div>
      </div>
    </div>

    <div class="cell has-border">
      <div class="prepend">
        <div class="prepend-icon">
          <iain-image-domain w="28" h="32" src="static/img/icon7.png" />
        </div>
        <span class="prepend-label">联系电话:</span>
        <span>{{ detail.mobile }}</span>
      </div>
    </div>

    <div class="cell">
      <div class="prepend">
        <div class="prepend-icon">
          <iain-image-domain w="28" h="32" r="6" src="static/img/icon8.png" />
        </div>
        <span class="prepend-label">已报人员:</span>
        <span>{{ joinUserTotal }}人</span>

        <ul class="prepend-users">
          <li v-for="(item, index) in joinUserList" :key="index" class="prepend-users-item">
            <iain-image-domain w="40" h="40" :src="item.avatar" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    initiator() {
      return this.detail.initiator || {}
    },
    joinUser() {
      return this.detail.joinUser || {}
    },
    joinUserList() {
      return this.joinUser.joinUsersList || []
    },
    joinUserTotal() {
      return this.joinUser.joinNum || 0
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .cell {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    min-height: 90px;

    .prepend {
      display: flex;
      align-items: center;
      flex-grow: 1;

      span {
        flex-shrink: 0;
      }

      .prepend-icon {
        width: 48px;
      }

      .prepend-label {
        margin-right: 15px;
      }

      .prepend-admin {
        color: #656565;
        margin-left: 10px;
      }

      .prepend-location {
        width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .prepend-users {
        display: flex;
        padding-left: 15px;
        overflow: hidden;

        .prepend-users-item {
          padding: 0 5px;
        }
      }
    }

    .append {
      display: flex;
      justify-content: space-between;
      width: 240px;
    }

    &.has-border {
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 30px;
        width: 690px;
        height: 1px;
        background: rgba(237, 237, 237, 1);
      }
    }
  }

  .mini {
    padding: 20px 0;

    .cell {
      height: 60px;
    }
  }
}
</style>
